
import React, { useState, useEffect } from 'react';
import {
    Button,
    Grid,
    Box,
    Divider,
    Container,
    CircularProgress,
    Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import Swal from 'sweetalert2';
import { useSelector, useDispatch } from 'react-redux';
import { CustomTitle } from '../../../common/CustomTitle/CustomTitle';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { startUsersActive } from '../../../../reducers/users/usersActions';
import { AddToContractsList } from './AddToContractsList/AddToContractsList';
import { contractsAddUser } from '../../../../hooks/useContractsAddUser';
import { GoBack } from '../../../common/GoBack/GoBack';
export const UserAddContractsScreen = () => {
    const { id } = useParams();
    const user = useSelector((state) => state.users.active);
    const activeContract = useSelector((state) => state.contracts.activeContract);



    const [selectedContracts, setSelectedContracts] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const contracts = useSelector((state) => state.contracts.contracts);
    const contractsLoaded = contracts && contracts.length > 0;

    // Carga el usuario si se navega directamente a esta URL
    useEffect(() => {
        if (id) dispatch(startUsersActive(id));
    }, [id, dispatch]);

    // Rellena el formulario cuando los datos del usuario llegan de Redux
    useEffect(() => {
        if (id && user === null && activeContract != null) {
            dispatch(startUsersActive(id));
        }
    }, [id, user, activeContract]);

    const handleSelectedContractsChange = (contracts) => {
        setSelectedContracts(contracts);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!user?.id) return;

        if (selectedContracts.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Debes seleccionar al menos un contrato',
                confirmButtonColor: '#3085d6',
            });
            return;
        }



        // Generar información para mostrar en el cartel de confirmación.
        const contractsInfo = selectedContracts.map(
            (contract) =>
                `<b>Contrato:</b> ${contract.name}<br/>
             <b>Permisos:</b> ${contract.permissions}<br/>
             <b>Tipo:</b> ${contract.type}<br/>`
        ).join('<hr/>');

        const confirmationText = `
      <b>Nombre de usuario:</b> ${user.name}<br/>
      <b>Email:</b> ${user.email}<br/><br/>
      <b>Contratos a añadir: </b><br/>${contractsInfo}
    `;

        // Mostrar cartel de confirmación.
        const { isConfirmed } = await Swal.fire({
            title: 'Confirmar asignación de contratos',
            html: `<div style="max-height: 400px; overflow-y: auto; text-align: center; padding-right: 8px;">
               ${confirmationText}
           </div>`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });

        if (!isConfirmed) {
            return; // Cancelar la creación si no se confirma.
        }

        try {
            Swal.fire({
                title: 'Añadiendo contratos...',
                text: 'Por favor espera',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });

            const selectedContractsData = selectedContracts.map(
                ({ id, name, permissions, type }) => ({ id, name, permissions, type })
            );

            await contractsAddUser({ userId: user.id, contracts: selectedContractsData });

            setSelectedContracts([]);
            dispatch(startUsersActive(id)); // Recarga el usuario para que se actualice la lista

            /*
                  Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'El usuario y sus permisos fueron creados correctamente',
                    confirmButtonColor: '#3085d6',
                  });
            */

            navigate('/users-management');
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Hubo un problema: ${error.message}`,
                confirmButtonColor: '#d33',
            });
        }
    };
    /*
      const handleDebug = () => {
        const debugUserData = prepareUserData();
      };
    */
    return (

        <Container maxWidth={false} sx={{ padding: 2 }}>
            <Grid xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <GoBack />
                <CustomTitle title={`Añadir contratos a ${user?.name}`} icon={<GroupAddIcon />} advanced={true} />
            </Grid>
            <Grid>
                <Divider sx={{ padding: 2 }} />
            </Grid>
            <Box sx={{ maxWidth: 1400, mx: 'auto', p: 3 }}>
                <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="h6">Nombre: {user?.name}</Typography>
                    <Typography variant="h6">Email: {user?.email}</Typography>
                    <Typography variant="h6">Compañía: {user?.company}</Typography>
                </Box>
                <form onSubmit={handleSubmit}>

                    <Box sx={{ my: 2 }}>
                        <Divider />
                    </Box>

                    <Box>

                        <AddToContractsList onSelectedContractsChange={handleSelectedContractsChange} userId={id} />

                    </Box>
                    {/*
                    
                    
                    {selectedContracts?.map((contract) => (
                        <Box key={contract.id} sx={{ my: 3, p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
                            <Typography variant="h5">Configuración de usuario en el contrato {contract.name}</Typography>
                            <FormControl sx={{ my: 2 }}>
                                <FormLabel>Permisos</FormLabel>
                                <RadioGroup
                                    row
                                    value={contract.permissions}
                                    onChange={(e) => handlePermissionChange(contract.id, e.target.value)}
                                >
                                    <FormControlLabel value="supervisor" control={<Radio />} label="Supervisor" />
                                    <FormControlLabel value="manager" control={<Radio />} label="Gestor" />
                                    <FormControlLabel value="administrator" control={<Radio />} label="Administrador" />
                                    <FormControlLabel value="super_administrator" control={<Radio />} label="Super Administrador" />
                                </RadioGroup>
                            </FormControl>

                            <FormControl sx={{ my: 2 }}>
                                <FormLabel>Tipo</FormLabel>
                                <RadioGroup
                                    row
                                    value={contract.type}
                                    onChange={(e) => handleTypeChange(contract.id, e.target.value)}
                                >
                                    <FormControlLabel value="CM" control={<Radio />} label="CM" />
                                    <FormControlLabel value="P2P" control={<Radio />} label="P2P" />
                                    <FormControlLabel value="P2P/CM" control={<Radio />} label="P2P/CM" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    ))}
                        */}

                </form>

                <Grid item xs={12} sx={{ my: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={!contractsLoaded}
                    >
                        {!contractsLoaded ? <CircularProgress size={24} /> : 'Añadir contratos'}
                    </Button>
                </Grid>

                {
        /*<Grid item xs={12} sx={{ my: 2 }}>
          <Button variant="outlined" color="secondary" onClick={handleDebug}>
            Depurar Datos
          </Button>
        </Grid>
        */}
            </Box>
        </Container>

    );
};









